// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3xY20","success":"Button_success__cZcmp","error":"Button_error__1Dm6G","primary":"Button_primary__2Lwzk"};